const ERROR_MESSAGES = {
  'not-allowed': 'Microphone access was blocked. Enable it in your browser settings.',
  'no-mic': 'No microphone found. Connect one, or use this app on a phone or laptop.',
  unsupported: 'Voice recording is unavailable in this browser. Try Chrome or Safari.',
  'record-failed': 'Recording stopped unexpectedly. Please try again.',
  empty: 'That recording came through empty. Please try again, or type it.',
  'no-speech': "I didn't catch any words there — try again, closer to the mic.",
  'too-long': 'That recording was too long. Please try a shorter one.',
  'rate-limited': 'Slow down a moment — too many recordings in a row.',
  'transcribe-failed': "Couldn't transcribe that just now. Please try again, or type it.",
};

/** Status line under the mic: recording state, transcribing, or why it failed. */
export default function VoiceStatus({ supported, listening, transcribing, error }) {
  if (!supported) {
    return (
      <p className="text-xs text-gray-500 dark:text-gray-400 text-center max-w-xs">
        Voice recording isn&apos;t available in this browser — try Chrome or
        Safari. On a phone, the mic key on your keyboard works anywhere.
      </p>
    );
  }

  if (error) {
    return (
      <p className="text-xs text-rose-600 dark:text-rose-400 text-center max-w-xs">
        {ERROR_MESSAGES[error] || 'Voice input hit a problem. Try again.'}
      </p>
    );
  }

  if (transcribing) {
    return (
      <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
        Transcribing…
      </p>
    );
  }

  return (
    <p className="text-xs text-gray-500 dark:text-gray-400 text-center">
      {listening ? 'Recording — tap to finish' : 'Tap to speak'}
    </p>
  );
}
